import { render, staticRenderFns } from "./transferenciainstitucionxasesor.vue?vue&type=template&id=0e50f322&scoped=true"
import script from "./transferenciainstitucionxasesor.vue?vue&type=script&lang=js"
export * from "./transferenciainstitucionxasesor.vue?vue&type=script&lang=js"
import style0 from "./transferenciainstitucionxasesor.vue?vue&type=style&index=0&id=0e50f322&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e50f322",
  null
  
)

export default component.exports